module.exports = __webpack_public_path__ + "02_veryshort_grey.d59bf4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_veryshort_grey.png
// module id = GMSa
// module chunks = 0